/*
 * CONTAINES FUNCTIONS THAT ARE USEFUL FOR FINDING GEOLOCATION
 * 
 
 */ 

	function getDeviceCurrentLocation(){
	
		if (navigator.geolocation) {
			
			let options = {
					
					enableHighAccuracy : true,
					timeout : 5000,
					maximumAge : 0
					
			};
	
			//return navigator.geolocation.getCurrentPosition(showPosition, showError);
			
			smetio_isGeolocationSupported = true;
			
			smetio_watchDevicePositionId = navigator.geolocation.watchPosition(showPosition, showError,  options);
			
			return SMETIO_GEOLOCATION_AVAILABLE;
	
		}else{
			
			smetio_isGeolocationSupported = false;
			
			return SMETIO_GEOLOCATION_UNAVAILABLE;
			
		};
	
	};
	
	//$("body").on("load",function(){
						
		if(smetio_isLocationPermissionAlreadyGranted == 1 && smetio_latitudeOfTheDevice == SMETIO_UNKNOWN){
						
			getDeviceCurrentLocation();
			
		};
			
	//});
	
	function showPosition(position){
		
		/* STORE ON LOCATION STORAGE THAT PERMISSION HAS BEEN GRANTED TO ACCESS LOCATION */
		
		localStorage.setItem(SMETIO_LOCAL_STORAGE_LOCATION_PERMISSION_GRANTED, 1);
		
		smetio_isLocationPermissionAlreadyGranted = 1;
		
		
		
		// ALL THE SMETIO VARIABLES HERE ARE GLOBAL VARIABLES
	    
		smetio_latitudeOfTheDevice = position.coords.latitude;

		smetio_longitudeOfTheDevice = position.coords.longitude;
		
		smetio_accuracyOfDeviceLocation = position.coords.accuracy;
		
		smetio_altitudeOfDevice = position.coords.altitude;
		
		smetio_altitudeAccuracyOfDevice = position.coords.altitudeAccuracy;
		
		smetio_deviceIsheading = position.coords.heading;
		
		smetio_deviceSpeed = position.coords.speed;
			
		smetio_deviceLocationStatus = SMETIO_LOCATION_KNOWN;
				
		let gmapSrc = "https://maps.google.co.uk?q="+smetio_latitudeOfTheDevice+","+smetio_longitudeOfTheDevice+"&output=embed";
		
		$("#gmaps").attr("src",gmapSrc);
		
		$(".lat").html(smetio_latitudeOfTheDevice);
		
		$(".long").html(smetio_longitudeOfTheDevice);
		
		
		return smetio_deviceLocationStatus;
			
	};
	
	function showError(error) {
			
		switch(error.code) {
	
			case error.PERMISSION_DENIED:
	
				smetio_deviceLocationStatus = SMETIO_PERMISSION_DENIED;
				
				/* STORE ON LOCATION STORAGE THAT PERMISSION WAS NOT GRANTED TO ACCESS LOCATION */
				
				localStorage.setItem(SMETIO_LOCAL_STORAGE_LOCATION_PERMISSION_GRANTED, 0);
	
				return false; 
	
				break;
	
			case error.POSITION_UNAVAILABLE:
	
				smetio_deviceLocationStatus = SMETIO_POSITION_UNAVAILABLE;
	
				return false; 
	
				break;
	
			case error.TIMEOUT:
	
				smetio_deviceLocationStatus = SMETIO_TIMEOUT;
	
				return false; 
	
				break;
	
			case error.UNKNOWN_ERROR:
	
				smetio_deviceLocationStatus = SMETIO_UNKNOWN_ERROR;
	
				return false; 
	
				break;
	
			default : return false;
	
		};
		
		return smetio_deviceLocationStatus;
	
	};
	
	
	
	
	
	